<script>
    import { getResourceTypeLabel } from "../constants/resourceTypes.js";

    /**
     * @type {Array<{resource: {resourceId: number, resourceType: string}, details: any, nestedResources?: Array}>}
     */
    export let items = [];

    /**
     * @type {(resource: {resourceId: number, resourceType: string}, details: any) => void}
     */
    export let onItemClick = () => {};

    // Debug logging
    console.log('[ResourceList] items:', items);
</script>

<ul class="list bg-base-100">
    {#each items as { resource, details, nestedResources }, index}
        {@const label = getResourceTypeLabel(resource.resourceType)}
        {@const hasNested = nestedResources && nestedResources.length > 0}
        {console.log(`[ResourceList] Item ${index}:`, { resource, details, nestedResources, label, hasNested })}
        <li
            class="list-row {!hasNested ? 'cursor-pointer hover:bg-base-200' : ''} transition-colors border-2 border-base-content/30 rounded-lg mb-2"
            on:click={() => !hasNested && onItemClick(resource, details)}
            role={!hasNested ? "button" : undefined}
            tabindex={!hasNested ? "0" : undefined}
        >


                    <div class="list-col-grow {hasNested ? 'cursor-pointer hover:bg-base-200' : ''}" on:click={() => hasNested && onItemClick(resource, details)}>
                        <span class="badge badge-primary badge-sm">{label}</span>
                        {#if details}
                            <span class="text-base-content text-base font-medium">
                                {details.title || details.name || `Resource #${resource.resourceId}`}
                            </span>
                        {:else}
                            <span class="text-base-content text-base font-medium">Resource #{resource.resourceId}</span>
                        {/if}

                    </div>




            {#if details?.description || hasNested}
                <p class="list-col-wrap text-ms">
                    <span class="ml-10"></span>{details.description}<span/>

                    {#if hasNested}
                        {console.log('[ResourceList] Rendering nested resources:', nestedResources)}
                        <div class="nested-resources">
                            <svelte:self
                                items={nestedResources}
                                onItemClick={(resource, details) => {
                                    console.log('[ResourceList] Nested item clicked:', resource, details);
                                    onItemClick(resource, details);
                                }}
                            />
                        </div>
                    {/if}
                </p>
            {/if}

            <button class="btn btn-square btn-ghost" on:click={(e) => { e.stopPropagation(); onItemClick(resource, details); }}>
              <svg class="size-[1.2em]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g stroke-linejoin="round" stroke-linecap="round" stroke-width="2" fill="none" stroke="currentColor"><path d="M6 3L20 12 6 21 6 3z"></path></g></svg>
            </button>
        </li>
    {/each}
</ul>

<style>
    .cursor-pointer {
        cursor: pointer;
    }

    .nested-resources {
        margin-top: 0.75rem;
        padding-left: 1rem;
        border-left: 2px solid rgba(0, 0, 0, 0.1);
    }

    .nested-resources :global(.list) {
        box-shadow: none;
        background: transparent;
    }

    .nested-resources :global(.list-row) {
        padding: 0.5rem;
        font-size: 0.9rem;
    }
</style>
